import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { Outlet, useLocation } from 'react-router-dom';

import Logo from 'components/common/Logo';
import { AUTH_BRAND, DEFAULT_AUTH_BRAND } from 'constants/authBrand';
import { useTheme } from 'contexts/ThemeContext';
import { AuthBrandPanel } from 'views/auth/components/AuthBrandPanel';

/** Round light/dark toggle, pinned to the top-right of the form panel. */
function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();
  return (
    <button
      type="button"
      onClick={toggleTheme}
      title="Toggle theme"
      aria-label="Toggle theme"
      className="absolute right-4 top-4 z-20 flex h-10 w-10 items-center justify-center rounded-full border border-hair bg-paper text-slate transition-colors hover:bg-mist hover:text-ink sm:right-6 sm:top-6"
    >
      {isDark ? <SunIcon className="h-[19px] w-[19px]" /> : <MoonIcon className="h-[19px] w-[19px]" />}
    </button>
  );
}

/**
 * Full-screen responsive auth shell.
 * - Phone / tablet (<lg): single column — compact brand logo above the form
 *   (brand panel hidden).
 * - Desktop (lg+): edge-to-edge two-column split — light brand panel + form.
 */
export function AuthLayout() {
  const { pathname } = useLocation();
  const brand = AUTH_BRAND[pathname] || DEFAULT_AUTH_BRAND;

  return (
    <div className="grid min-h-[100dvh] w-full bg-surface lg:grid-cols-2">
      {/* Desktop brand panel (hidden below lg) */}
      <AuthBrandPanel {...brand} />

      {/* Form panel */}
      <div className="relative flex items-center justify-center px-5 py-16 sm:px-10 lg:px-16">
        <ThemeToggle />

        <div className="w-full max-w-[420px]">
          {/* Compact brand logo for phone / tablet (no brand panel there) */}
          <div className="mb-9 lg:hidden">
            <Logo size={26} />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
